<template>
  <div class="message-screen-list" v-loading="loading">
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}</el-button
          >
        </div>
        <div class="group-right">
          <el-button v-if="multipleSelection.length" type="primary" @click="screenContorl(1)" size="small" round>{{$t('screen.click_open')}}</el-button>
          <el-button v-if="multipleSelection.length" type="info"  @click="screenContorl(0)" size="small" round>{{$t('screen.click_close')}}</el-button>
          <el-tooltip class="refresh-item" effect="dark" placement="bottom">
            <el-button icon="el-icon-refresh"  @click="getTableData(pageInfo.page)" size="small" circle style="margin-left: 20px;"></el-button>
          </el-tooltip>
        </div>
      </div>
      <el-table 
        :data="tableData"
        style="width: 100%"
        :row-key="getRowKey"
        @selection-change="handleSelectionChange"
        stripe>
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="55">
        </el-table-column>
        <!-- <el-table-column prop="id" label="ID" width="100"> </el-table-column> -->
        <el-table-column prop="name" :label="$t('screen.name')"> </el-table-column>
        <el-table-column prop="number" :label="$t('screen.number')"> </el-table-column>
        <el-table-column prop="area_code" :label="$t('screen.area_code')"> </el-table-column>
        <el-table-column prop="lamp_name" :label="$t('screen.lamp_name')"> </el-table-column>
        <el-table-column prop="screen_type" :label="$t('screen.brand')">
          <template slot-scope="scope">
            {{ screenType[scope.row.screen_type] }}
          </template>
        </el-table-column>
        <el-table-column prop="ste" :label="$t('screen.state')">
          <template slot-scope="scope">
            <i :class="steColorType[scope.row.ste]"></i>
            <span>{{ steType[scope.row.ste] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pattern" :label="$t('screen.device_mode')">
          <template slot-scope="scope">
            <span>{{ patternType[scope.row.pattern] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" :label="$t('screen.add_time')">
          <template slot-scope="scope">
            <span>{{ $commonJs.formatDate(parseInt(scope.row.created_at)*1000) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="edit" :label="$t('control.operate')" width="100">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? $t('control.add') : $t('control.edit')"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-form-item :label="$t('screen.name')" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('screen.number')" prop="number">
            <el-input v-model="editOne.number"></el-input>
          </el-form-item>
          <el-form-item :label="$t('screen.area_code')" prop="area_code">
            <el-input v-model="editOne.area_code"></el-input>
          </el-form-item>

          <el-form-item :label="$t('screen.brand')" prop="screen_type" v-if="editType === 'create'">
            <el-select
              :placeholder="$t('screen.select_brand')"
              v-model="editOne.screen_type"
              style="width: 100%"
            >
              <el-option :label="$t('screen.brand1')" :value="0"></el-option>
              <el-option :label="$t('screen.brand2')" :value="1"></el-option>
              <el-option :label="$t('screen.brand3')" :value="3"></el-option>
              <el-option :label="$t('screen.brand4')" :value="4"></el-option>
            </el-select>
          </el-form-item>
   
          <el-form-item :label="$t('screen.lamp_name')">
            <el-select
              clearable
              filterable 
              :placeholder="$t('screen.select_lamp_name')"
              v-model="editOne.lamp_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in lampList"
                :key="t.lamp_id"
                :label="t.name"
                :value="t.lamp_id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('screen.device_mode')" prop="pattern">
            <el-select
              :placeholder="$t('screen.select_device_mode')"
              v-model="editOne.pattern"
              style="width: 100%"
            >
              <el-option :label="$t('screen.public_network')" :value="0"></el-option>
              <el-option :label="$t('screen.intranet')" :value="1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="editOne.pattern" :label="$t('control.ip')" prop="device_address">
            <el-input v-model="editOne.device_address"></el-input>
          </el-form-item>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >{{$t('control.confirm')}}</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import lampsApi from "@/api/device/lamps"
import screenApi from "@/api/message/screenList"
export default {
  data() {
    return {
      steType: this.$t('device.steList'),
      steColorType: ["valuered", "valuegreen"],
      screenType: this.$t('screen.screenType'),
      patternType: this.$t('screen.patternType'),
      loading: false,
      dialogVisible: false,
      lampList: [],
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      editOneRule: {
        name: [{ required: true, message: this.$t('device.please_name'), trigger: "blur" }],
      },
      editType: -1,
      devSelect: [],
      editOne: {
        name: '',
        number: '',
        area_code: '0',
        lamp_id: '',
        screen_type: 0,
        pattern: '',
        device_address: '',
      },
      multipleSelection: [],
      manualChange: false
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      screenApi.screenList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.getLampList()
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          name: '',
          number: '',
          area_code: '0',
          lamp_id: '',
          screen_type: 0,
          pattern: '',
          device_address: '',
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          name: index.name,
          number: index.number,
          area_code: index.area_code,
          lamp_id: index.lamp_id,
          screen_type: index.screen_type,
          pattern: index.pattern,
          device_address: index.device_address
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      screenApi.screenEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.mod_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      screenApi.screenAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.add_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getLampList() { // 获取灯组列表
      lampsApi.lightList({
        // lamp_protocol: 3,
        page: 1,
        pageSize: 200,
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.lampList = resData.list;
        }
      });
    },
    delItem(id) {
      this.$confirm(this.$t('control.tip_del_data_title'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          screenApi.screenDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.del_success'));
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del'),
          });
        });
    },

    getRowKey (row) {
      return row.id
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    screenContorl(type){ //查询所选中的设备
      let selVal = this.multipleSelection
      if(selVal.length<1){
        this.$message.error(this.$t('screen.select_screen'));
      }
      let mulVal= '';
      for(let i=0; i<selVal.length; i++){
        mulVal=mulVal+selVal[i].id+','
      }
      mulVal=mulVal.slice(0,mulVal.length-1)
      screenApi.screenContorl({ screenId: mulVal,type:type }).then((res) => {
        // console.log('screenList',res)
        if (res.code === 200) {
          this.$message.success(res.msg)
          this.getTableData(this.pageInfo.page)
        } else {
          this.$message.error(res.msg)
        }
      });
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  }
};
</script>
<style lang='less'>
.message-screen-list{
  width: 100%;
  .form-info{
    padding-left:10px;
    .el-form-item__label{
      width:85px;
    }
  }
}

</style> 